<template>
  <authorization permissionKey="configuration_facilitator_glasses_prescription" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Facilitadores de receita de óculos
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" color="secondary">
            <v-tab v-for="(value, key) in facilitatorTypes" :key="key">
              {{ value }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(value, key) in facilitatorTypes" :key="key">
              <GlassesPrescriptionList
                :facilitators="glassesPrescriptionFacilitators"
                :facilitatorType="key"
                :refreshList="refreshList"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import GlassesPrescriptionList from "@/components/config/glasses_prescription/list/index.vue";

  export default {
    name: "GlassesPrescriptionConfig",
    components: {
      GlassesPrescriptionList,
    },
    data() {
      return {
        tab: null,
        facilitatorTypes: {
          notes: "Observação",
          spherical: "Esférico",
          cylindrical: "Cilindrico",
          axis: "Eixo",
          addition: "Adição",
          pupillary_distance: "Distancia pupilar",
        },
      };
    },
    apollo: {
      glassesPrescriptionFacilitators: {
        query: require("@/graphql/glasses_prescription/facilitators.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.glassesPrescriptionFacilitators.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
